// GA4 helper wrapper
// Usage: import { track } from '@/lib/ga'; track('lead_form_submit', { method: 'mro' })

export type GAEventName =
  | 'lead_form_submit'
  | 'adobe_sign_click'
  | 'monthly_report_click'
  | 'click_to_call'
  | 'click_to_email'
  | 'newsletter_signup'
  | 'footer_link_click'

export type GAEventParams = Record<string, string | number | boolean | undefined>

export function track(eventName: GAEventName, params?: GAEventParams) {
  if (typeof window === 'undefined') return
  const w = window as any
  if (!w.gtag) return
  try {
    w.gtag('event', eventName, {
      ...params,
    })
  } catch (_) {
    // no-op
  }
}
